<template>
  <v-card elevation="0" style="border-radius: 10px" @drop="handleDrop">

    <!-- ── Full-page skeleton while initial APIs load ── -->
    <template v-if="pageLoading">
      <!-- Title row -->
      <v-card-item class="pb-0">
        <div class="cl-sk-title-row">
          <div class="cl-sk-bone" style="width:160px; height:18px; border-radius:4px;" />
          <div class="cl-sk-bone" style="width:28px; height:28px; border-radius:50%;" />
        </div>
      </v-card-item>

      <v-card-text class="pt-3">

        <!-- Row 1: radio + switch -->
        <div class="cl-sk-row mb-4">
          <div class="cl-sk-col-half cl-sk-row" style="gap:24px; padding-right:8px;">
            <div class="cl-sk-bone" style="width:80px; height:20px; border-radius:10px;" />
            <div class="cl-sk-bone" style="width:80px; height:20px; border-radius:10px;" />
          </div>
          <div class="cl-sk-col-half" style="padding-left:8px;">
            <div class="cl-sk-bone" style="width:110px; height:20px; border-radius:10px;" />
          </div>
        </div>

        <!-- Row 2: Pending With + FollowUp Date -->
        <div class="cl-sk-row mb-4" style="align-items:flex-start;">
          <!-- Pending With -->
          <div class="cl-sk-col-half" style="padding-right:4px;">
            <div class="cl-sk-bone mb-1" style="width:90px; height:13px; border-radius:3px;" />
            <div class="cl-sk-bone" style="width:100%; height:40px; border-radius:6px;" />
          </div>
          <!-- FollowUp Date -->
          <div class="cl-sk-col-half" style="padding-left:4px;">
            <div class="cl-sk-bone mb-1" style="width:100px; height:13px; border-radius:3px;" />
            <div class="cl-sk-bone" style="width:100%; height:40px; border-radius:6px;" />
          </div>
        </div>

        <!-- Row 3: Description -->
        <div class="mb-4">
          <div class="cl-sk-bone mb-1" style="width:80px; height:13px; border-radius:3px;" />
          <!-- toolbar strip -->
          <div class="cl-sk-bone mb-1" style="width:100%; height:36px; border-radius:6px 6px 0 0;" />
          <!-- editor body -->
          <div class="cl-sk-bone" style="width:100%; height:100px; border-radius:0 0 6px 6px;" />
        </div>

        <!-- Row 4: Attachments -->
        <div>
          <div class="cl-sk-bone" style="width:100%; height:56px; border-radius:8px;" />
        </div>

      </v-card-text>

      <!-- Footer buttons -->
      <div class="cl-sk-footer">
        <div class="cl-sk-bone" style="width:80px; height:35px; border-radius:6px;" />
        <div class="cl-sk-bone" style="width:80px; height:35px; border-radius:6px;" />
      </div>
    </template>

    <!-- ── Real form (shown after load) ── -->
    <v-form v-else @submit.prevent="save" ref="form">
      <v-card-item>
        <v-card-title>
          {{
            this.type === "action" && !showReadOnly
              ? "Edit"
              : showReadOnly
                ? "View"
                : "Add"
          }}
          Clarification
          <v-avatar size="x-small" color="primary" v-if="no_of_followups">
            {{ no_of_followups }}
          </v-avatar>
          <v-btn style="float: right" @click="close()" elevation="0" density="comfortable" icon="mdi-close"></v-btn>
        </v-card-title>
      </v-card-item>

      <v-card-text>
        <v-row no-gutters>
          <v-col cols="6" class="px-0 py-0" style="display: grid">
            <v-radio-group :disabled="showReadOnly" v-model="formData.followup_type" inline
              @change="getUsers(formData.followup_type)" v-if="true">
              <v-radio color="primary" label="Internal" :value="1"></v-radio>
              <v-radio color="error" label="External" :value="0"></v-radio>
            </v-radio-group>
          </v-col>
          <v-col cols="6" class="px-0 py-0">
            <v-switch v-model="formData.clarification_critical" color="primary" label="Critical"
              hide-details></v-switch>
          </v-col>
          <v-col v-if="false" cols="6" class="px-0 py-0" style="display: grid">
            <v-label class="pb-1" style="font-size: 14px; color: #272727; font-weight: 600">Clarification Type
            </v-label>
            <div style="font-size: 14px; color: #272727; font-weight: 600">
              {{ formData.followup_type == 1 ? "Internal" : "External" }}
            </div>
          </v-col>

          <v-col cols="6" class="pr-1" v-if="true">
            <v-label class="pb-1" style="font-size: 14px; color: #272727; font-weight: 600">
              Pending With
              <span style="color: #cf0707; padding-left: 2px; font-weight: 700">*</span></v-label>
            <AutoComplete :disabled="showReadOnly" class="dropdown" :items="users" :item-title="'name'" 
              multiple="true" :item-value="'id'" density="compact" v-model="formData.user"
              placeholder="User" :rules="userRule" />
          </v-col>
          <v-col v-if="false" cols="6">
            <v-label class="pb-1" style="font-size: 14px; color: #272727; font-weight: 600">Pending With
            </v-label>
            <div style="font-size: 14px; color: #272727; font-weight: 600">
              {{ formData.pending_with_name ? formData.pending_with_name : "null" }}
            </div>
          </v-col>

          <v-col cols="6" class="pl-1" v-if="!showReadOnly">
            <v-label class="pb-1" style="font-size: 14px; color: #272727; font-weight: 600">FollowUp Date
              <span v-if="true" style="color: #cf0707; padding-left: 2px; font-weight: 600">*</span></v-label>
            <TextFieldComponent :showReadOnly="showReadOnly" density="compact" placeholder="FollowUp date"
              :rules="dateRule" v-model="formData.followup_date" type="date" />
          </v-col>

          <v-col v-if="showReadOnly && formData.followup_date">
            <v-label class="pb-1" style="font-size: 14px; color: #272727; font-weight: 600">FollowUp Date
            </v-label>
            <div style="font-size: 14px; color: #272727; font-weight: 600">
              {{
                formData &&
                  formData.followup_date &&
                  moment(formData.followup_date).format("MM/DD/YYYY") != "Invalid date"
                  ? moment(formData.followup_date).format("MM/DD/YYYY")
                  : ""
              }}
            </div>
          </v-col>

          <v-col cols="12" v-if="true">
            <v-label class="pb-1" style="font-size: 14px; color: #272727; font-weight: 600">Description</v-label>
            <DescriptionVue :data="formData.description" :showReadOnly="showReadOnly"
              @textData="changeDescription($event)" ref="descriptionVue">
            </DescriptionVue>
          </v-col>
          <v-col v-if="false" cols="12">
            <v-label class="pb-1" style="font-size: 14px; color: #272727; font-weight: 600">Description
            </v-label>
            <v-card style="background-color: rgba(224, 243, 253, 0.325)" flat>
              <v-card-text>
                <div v-html="formData.description"></div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <Attachments :fileForUpload="fileForUpload" :type="'file'" :uploadFor="'clarification'" :issueId="issueId"
              :showEdit="true" :exceptStage="true" @removeDoc="removeDoc" />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-action class="mr-3" v-if="!showReadOnly">
        <v-row justify="end" class="dialogBottom">
          <v-btn style="--v-btn-height: 35px" class="mr-2 cancel" @click="close()">Cancel</v-btn>
          <v-btn style="--v-btn-height: 35px" :loading="saveClicked" class="save" type="submit">Save</v-btn>
        </v-row>
      </v-card-action>
    </v-form>

  </v-card>
</template>

<script>
import AutoComplete from "@/components/ui/AutoComplete.vue";
import moment from "moment";
// import TextArea from "@/components/ui/TextArea.vue";
import IssueService from "@/api/service/Issue/IssueService";
import ForumService from "@/api/service/Forum/ForumService";
// import EnumAutoCompleteVue from "@/components/others/EnumAutoComplete.vue";
import TextFieldComponent from "@/components/TextFieldComponent.vue";
import ContactService from "@/api/service/Contact/ContactService";
import UserService from "@/api/service/UserService";
import commonService from '@/common.service';
import DescriptionVue from "@/components/ui/Description.vue";
import Attachments from "./Attachments.vue";
import IssueFollowupUserService from "@/api/service/IssueFollowupUsers/IssueFollowupUserService.js";

export default {
  components: {
    // TextArea,
    // EnumAutoCompleteVue,
    AutoComplete,
    TextFieldComponent,
    DescriptionVue,
    Attachments
  },
  props: ["issueId", "followUpNo", "showDetails", "showReadOnly", "type", "clariAccountId"],
  data() {
    return {
      fileForUpload: null,
      saveClicked: false,
      switchMe: false,
      pageLoading: false,
      users: [],
      internalUsers: [],
      externalUsers: [],
      description: null,
      availableData: {},
      isUsersLoading: false,
      formData: {
        followup_type: 1,
        user: null,
        followup_date: null,
        clarification: null,
        description: null,
      },
      clarificationRule: [(value) => !!value || "Clarification is Required"],
      dateRule: [(value) => !!value || "Followup date is Required"],
      userRule: [(value) => !!value || "User is Required"],
    };
  },

  async created() {
    console.log(this.issueId, "isssssAtttttt")
    this.pageLoading = true;
    await this.initUsers();
    if (this.issueId) {
      let followups = await IssueFollowupUserService.findAll({
        issue_id: this.issueId,active:1
      });
      if (followups && followups.length > 0) {
        await this.getById(this.issueId);
      }
    }
    this.pageLoading = false;
  },
  methods: {
    moment,

    async getById(id) {
      let res = await IssueService.getClarificationDetails({
        issueId: id,
        type: "clarification",
      });
      this.availableData = res[0];
      console.log(this.availableData, "jjjjjiiii");

      this.formData.followup_type =
        this.availableData.followup_type == "internal" ? 1 : 0;
      this.getUsers(this.availableData.followup_type, true);
      const rawUser = this.availableData.followup_user;
      if (rawUser === null || rawUser === undefined) {
        this.formData.user = null;
      } else if (typeof rawUser === 'string' && rawUser.startsWith('[')) {
        this.formData.user = JSON.parse(rawUser);
      } else {
        this.formData.user = [parseInt(rawUser)];
      }
      this.formData.pending_with_name = this.availableData.pending_with_name;
      this.formData.clarification = this.availableData.clarification_type;
      this.formData.followup_date = this.availableData.followup_date
        ? moment(this.availableData.followup_date).format("YYYY-MM-DD")
        : null;
      // flat columns returned by getClarificationDetails
      this.formData.description = this.availableData.description || null;
      this.formData.f_id       = this.availableData.f_id || null;
      // id of the issue_followup_users row — used by save() to decide create vs update
      this.formData.ifu_id     = this.availableData.ifu_id || null;
      console.log(this.formData, "getById complete");
    },

    async removeDoc(data) {
      console.log(data, "newDocs");
      await IssueService.update({
        id: this.issueId,
        attachment: JSON.stringify(data),
      });
    },
    async handleDrop($event) {
      $event.preventDefault();
      this.fileForUpload = $event.dataTransfer.files;
      console.log(this.fileForUpload, "started");
    },
    setActiveButton(button) {
      this.formData.priority = button;
    },

    // Fetch both internal and external data upfront in parallel
    async initUsers() {
      this.isUsersLoading = true;
      const [internalRes, externalRes] = await Promise.all([
        UserService.findAll({ active: 1 }),
        ContactService.allContacts(),
      ]);
      this.internalUsers = internalRes && internalRes.length > 0 ? internalRes : [];
      this.externalUsers =
        externalRes && externalRes.length > 0
          ? externalRes.filter((contact) => contact.active === 1)
          : [];
      // Default to internal
      this.users = this.internalUsers;
      this.isUsersLoading = false;
    },

    // Switch the displayed list based on radio selection (no API call)
    getUsers(type, keepUser = false) {
      if (!keepUser) this.formData.user = null;
      if (type == 1 || type == "internal") {
        this.users = this.internalUsers;
      } else if (type == 0 || type == "external") {
        this.users = this.externalUsers;
      } else {
        this.users = [];
      }
    },

    itemProps(item) {
      return {
        title: item.first_name,
        subtitle: item.email,
      };
    },
    // clearFollowUpDate() {
    //   this.switchMe = false;
    //   this.formData.followup_date = null;
    // },
    close() {
      this.$emit("closeDialog");
    },
    changeClarification($event) {
      this.formData.clarification = $event;
    },
    changeDescription($event) {
      this.formData.description = $event;
    },

    async save() {
      let validation = await this.$refs.form.validate();
      if (!validation.valid) {
        console.log(validation.valid);
      } else {
        if (this.issueId) {
          if (!this.formData.description) {
            this.$refs.descriptionVue.showErrorMessage("Description is Required");
            return;
          }
          this.saveClicked = true;
          let $issueStatus = this.$store.getters.getIssueStatus;
          await IssueService.update({
            id: this.issueId,
            stage: "clarification",
            external_stage: "attention",
            followup_date: this.formData.followup_date,
            followup_type:
              this.formData.followup_type && this.formData.followup_type == 1
                ? "internal"
                : "external",
            clarification_critical:
              this.formData && this.formData.clarification_critical
                ? 1
                : 0,
            clarification_type:
              this.formData && this.formData.clarification
                ? this.formData.clarification
                : "",
          });

          // Build the shared followup payload
          const followupPayload = {
            issue_id: this.issueId,
            followup_date: this.formData.followup_date,
            followup_type:
              this.formData.followup_type && this.formData.followup_type == 1
                ? "internal"
                : "external",
            followup_user: this.formData.user,
            type:
              this.formData && this.formData.clarification
                ? this.formData.clarification
                : "clarification",
          };

          // Update existing row if we loaded one in edit mode, otherwise create
          if (this.formData.ifu_id) {
            await IssueFollowupUserService.update({
              id: this.formData.ifu_id,
              ...followupPayload,
            });
          } else {
            await IssueFollowupUserService.create(followupPayload);
          }
          if ($issueStatus && $issueStatus == 1) {
            this.$store.commit("SET_ISSUE_STATUS", 2);
          }
          let $description =
            this.formData && this.formData.description ? this.formData.description : "";
          let data = {
            id: this.formData.f_id ? this.formData.f_id : null,
            key_type: "issue",
            key_id: this.issueId,
            action: "clarification",
            description: $description,
            mentions: "cf"
          };
          if (data.id) {
            await ForumService.update(data);
          } else {
            await ForumService.create(data);
          }
          if (this.formData.followup_type != 1) {
            await IssueService.clarificationNotification({ id: this.issueId })
          }
          this.formData = {
            followup_type: 1,
            user: null,
            followup_date: null,
            clarification: null,
            description: "",
          };
          this.close();
          this.$emit("saveDialog");
        }
        let $data = { socketName: 'CLARIFICATION_INITIATED', accountId: this.clariAccountId }
        commonService.getClarificationSocket($data)
      }
    },
  },
};
</script>

<style scoped>
/* ── Skeleton layout helpers ── */
.cl-sk-title-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 4px 0;
}

.cl-sk-row {
  display: flex;
  align-items: center;
  width: 100%;
}

.cl-sk-col-half {
  width: 50%;
  flex-shrink: 0;
}

.cl-sk-footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 8px 16px 16px;
}

/* ── Animated shimmer bone ── */
.cl-sk-bone {
  background: linear-gradient(
    90deg,
    #e0e0e0 25%,
    #ececec 50%,
    #e0e0e0 75%
  );
  background-size: 200% 100%;
  animation: cl-shimmer 1.4s ease-in-out infinite;
  flex-shrink: 0;
}

.mb-1 { margin-bottom: 6px !important; }
.mb-4 { margin-bottom: 16px !important; }

@keyframes cl-shimmer {
  0%   { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}
</style>
